<template>
  <div class="CommentRecord">
    <a-form-model layout="inline" style="margin-top: 15px">
      <a-form-model-item label="游戏名称">
        <a-input placeholder="请输入游戏名称" allow-clear :maxLength="20" v-model="search.contentName" @keyup.enter="getList(1)" />
      </a-form-model-item>
      <a-form-model-item label="版本名称">
        <a-input placeholder="请输入" allow-clear :maxLength="30" v-model="search.versionName" @keyup.enter="getList(1)" />
      </a-form-model-item>
      <a-form-model-item label="游戏类型">
        <a-select allowClear v-model="search.contentType" placeholder="请选择游戏类型" style="width: 198px">
          <a-select-option :value="1">测评</a-select-option>
          <a-select-option :value="2">训练</a-select-option>
        </a-select>
      </a-form-model-item>
      <!-- <a-form-model-item label="评价均分">
        <a-input-group compact>
          <a-input-number style="width: 100px; text-align: center" placeholder="最低分" type="number" :precision="2" :min="0" :max="5" v-model="search.minScore" />
          <a-input style="width: 30px; border-left: 0; pointer-events: none; backgroundcolor: #fff" placeholder="~" disabled />
          <a-input-number style="width: 100px; text-align: center; border-left: none" placeholder="最高分" :precision="2" :min="search.minScore" :max="5" type="number" v-model="search.maxScore" />
        </a-input-group>
      </a-form-model-item> -->
      <a-form-model-item label="评价时间">
        <a-range-picker
          v-model="times"
          @change="changeRange"
          :show-time="{
            hideDisabledOptions: true,
          }"
          format="YYYY-MM-DD HH:mm:ss"
        />
      </a-form-model-item>
      <a-form-model-item>
        <a-button type="primary" @click="searchBtn">查询</a-button>
      </a-form-model-item>
    </a-form-model>
    <div class="table">
      <a-table :columns="columns" :scroll="{ y: 350 }" rowKey="id" @change="handleTableChange" :pagination="table.tablePagination" :loading="table.tableLoading" :dataSource="table.tableDataSource">
        <div slot="contentType" slot-scope="text">
          {{ text.contentType == 1 ? '测评' : '训练' }}
        </div>
        <div slot="evaluationRate" slot-scope="text">{{ text.evaluationRate }}%</div>
        <a v-permission="'/content/GamesComment/ViewRecord'" slot="action" slot-scope="text" @click="view(text)">查看</a>
      </a-table>
    </div>
  </div>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import moment from 'moment'
const columns = [
  { title: '游戏名', dataIndex: 'contentName' },
  { title: '版本名', dataIndex: 'versionName' },
  { title: '游戏类型', scopedSlots: { customRender: 'contentType' } },
  { title: '评价均分', sorter: true, dataIndex: 'evaluateScore' },
  { title: '评价次数', sorter: true, dataIndex: 'evaluateCount' },
  { title: '评价率', sorter: true, scopedSlots: { customRender: 'evaluationRate' }, key: 'evaluationRate' },
  { title: '最新评价时间', key: 'latestEvaluationTime', dataIndex: 'latestEvaluationTime' },
  { title: '操作', scopedSlots: { customRender: 'action' } },
]
export default {
  name: 'CommentRecord',
  data() {
    return {
      moment,
      times: [],
      search: {
        contentName: undefined,
        versionName: undefined,
        contentType: undefined,
        minScore: undefined,
        maxScore: undefined,
        orderBy: undefined,
        isDesc: undefined,
      },
      columns,
      table: tableRelevant.call(this),
    }
  },
  mounted() {
    Object.keys(this.$route.query).forEach((item) =>this.search[item] = this.$route.query[item])
    if (this.$route.query.startTime) {
      this.search.startTime = this.$route.query.startTime
      this.search.endTime = this.$route.query.endTime
      this.times = [moment(this.search.startTime), moment(this.search.endTime)]
    }
    if(this.search.contentType){
       this.$set(this.search,'contentType',+this.search.contentType)
    }
    this.getList(1)
  },
  methods: {
    searchBtn() {
      this.$router.push({
        query: {
          ...this.search,
          startTime: this.search.startTime,
          endTime: this.search.endTime,
        },
      })
      this.getList(1)
    },
    changeRange(e = []) {
      if (e.length === 0) {
        this.search.startTime = undefined
        this.search.endTime = undefined
      } else {
        this.search.startTime = moment(e[0]).format('YYYY-MM-DD HH:mm:ss')
        this.search.endTime = moment(e[1]).format('YYYY-MM-DD HH:mm:ss')
      }
      this.$router.push({
        query: {
          startTime: this.search.startTime,
          endTime: this.search.endTime,
        },
      })
    },
    clearSearch() {
      this.search = {
        contentName: undefined,
        versionName: undefined,
        contentType: undefined,
        minScore: undefined,
        maxScore: undefined,
        orderBy: undefined,
        isDesc: undefined,
      }
      this.getList(1)
    },
    // 获取列表数据
    getList(pageIndex) {
      let params = {
        pageIndex: pageIndex || this.table.tablePagination.current,
        pageSize: this.table.tablePagination.pageSize,
        ...this.search,
      }
      this.table.tableLoading = true
      this.$http.GamesComment.getEvaluateSummaryList(params).then((res) => {
        const { status, data, message } = res
          this.table.tableDataSource = data.items
          this.table.tablePagination.total = data.totalCount
          this.table.tablePagination.current = data.pageIndex
     
      }).finally(() => {
        this.table.tableLoading = false
      })
    },

    // 表格排序
    handleTableChange(pagination, filters, sorter) {
      if (sorter.order) {
        if (sorter.columnKey == 'evaluateScore') {
          this.search.orderBy = 1
        }
        if (sorter.columnKey == 'evaluateCount') {
          this.search.orderBy = 2
        }
        if (sorter.columnKey == 'evaluationRate') {
          this.search.orderBy = 3
        }
        if (sorter.order == 'descend') {
          this.search.isDesc = true
        } else if (sorter.order == 'ascend') {
          this.search.isDesc = false
        }
      } else {
        this.search.orderBy = undefined
        this.search.isDesc = undefined
      }
      this.getList()
    },

    // 查看
    view(text) {
      console.log(text)
      this.$router.push({
        path: '/content/GamesComment/ViewRecord',
        query: {
          contentId: text.contentId,
          startTime: this.search.startTime,
          endTime: this.search.endTime,
        },
      }),
        localStorage.setItem('commentRecord', JSON.stringify(text))
    },
  },
}
</script>

<style scoped>
.table {
  margin-top: 15px;
}
</style>
